/** "Sam is interpreting." */
export function interpreterChangedTitle(name) {
    const who = typeof name === 'string' ? name.trim() : '';
    return who ? `${who} is interpreting.` : 'Your interpreter changed.';
}
/**
 * The notice for this device's call, and its stored call with the new
 * interpreter's name (the room's labels read it), or null when the change is
 * for a call this device is not in.
 */
export function interpreterChangedNotice(stored, data) {
    const callId = typeof data?.callId === 'string' ? data.callId : '';
    if (!callId || !stored || stored.callId !== callId) {
        return null;
    }
    const name = typeof data?.interpreterName === 'string' ? data.interpreterName.trim() : '';
    return {
        nextStored: name ? { ...stored, interpreterName: name } : stored,
        title: interpreterChangedTitle(name),
        // One notice per transfer, however many processes announce it.
        uid: `call-interpreter-changed-${data?.transferId || callId}`
    };
}
